import { Formik } from 'formik';
import { Form } from '../../components/forms/Form';
import { TextField } from '../../components/forms/TextField';
import { Autocomplete } from '../../components/forms/Autocomplete';
import { countries } from 'bloggers-backend/lib/leads/dicts/countries';
import ButtonWithLoading from '../../components/forms/SubmitButton';
import { useCreateForm } from '../../components/forms/hooks/useCreateForm';
import { statuses } from 'bloggers-backend/lib/leads/dicts/statuses';
import { UserField } from '../../components/forms/UserField';

export default function CreateLeadPage() {
  const {isSubmitLoading, create, validate} = useCreateForm('leads', '/leads');

  return (<Formik
      initialValues={{
        name: '',
        category: '',
        status: '',
        country: '',
        website: '',
        email: '',

        additionalEmail: null,
        socialMedia: null,
        manager: null
      }}
      onSubmit={create}
      validate={validate}
    >
      <Form>
        <h2>Create a new lead:</h2>
        <TextField required name="name" label="name"/>
        <TextField required name="category" label="category"/>
        <Autocomplete required name="status" label="status" options={statuses}/>
        <Autocomplete required name="country" label="country" options={countries}/>
        <TextField required name="website" label="website"/>
        <TextField required name="email" label="email"/>
        <UserField name="manager" label="manager"/>

        <TextField name="additionalEmail" label="additional email"/>
        <TextField name="socialMedia" label="social media"/>
        
        <ButtonWithLoading loading={isSubmitLoading}/>
      </Form>
    </Formik>
  );
}
